import { type JSX, Show } from 'solid-js';
import { t } from '../../i18n';
import { controlKey } from '../../lib/card-controls';
import { useCardControls } from '../../lib/card-controls-context';
import { isSaving } from '../../lib/flood-guard-context';
import { ControlIcon } from './ControlIcon';

// "Pause all" / "Resume all" in the Now header (#6753, prototype allBtn, `:2284`): with two
// or more controllable jobs, "Pause all" while any of them runs, else "Resume all". One press
// is one server change (`POST /v1/runners/:id/pause-jobs|resume-jobs`) and one client change
// through the page's flood guard. This is NOT the drain ("Stop taking new work").

export function PauseAllButton(props: { readonly boxId: string }): JSX.Element {
  const handle = useCardControls();
  const shown = () => (handle?.on() === true && handle.card.allShown() ? handle : null);
  return (
    <Show when={shown()}>
      {(h) => {
        const saving = () => isSaving(h().card.page, controlKey.allJobs(props.boxId));
        const held = () => saving() || h().card.locked() > 0;
        const pause = () => h().card.allValue() === 'run';
        return (
          <button
            type="button"
            class="mission-ctl__all"
            aria-disabled={held() ? 'true' : undefined}
            aria-busy={saving() ? 'true' : undefined}
            onClick={() => {
              if (!held()) h().card.toggleAll();
            }}
          >
            <ControlIcon glyph={pause() ? 'pause' : 'play'} />
            {pause() ? t('fleet.machines.ctl_pause_all') : t('fleet.machines.ctl_resume_all')}
          </button>
        );
      }}
    </Show>
  );
}
